<template>
  <div class="affirmorderindex">
    <!--<van-nav-bar title="确认订单" fixed left-arrow @click-left="goBack" @click-right="onClickRight">-->

    <!--</van-nav-bar>-->
    <div style="padding-top: 0" class="van-content">
      <!--手机号码-->
      <van-cell-group v-if="datas.product_list[0].dummy == 1||datas.product_list[0].dummy == 2">
        <van-field v-model="mobile" label="手机号" placeholder="请输入手机号" />
      </van-cell-group>
      <!--地址-->
      <div v-if="datas.product_list[0].dummy != 1&&datas.product_list[0].dummy != 2"  style="position: relative;" @click="mysite" class="addInfo">
        <van-address-list class="address-list" style="padding-bottom:0" v-model="chosenAddressId" :list="siteList"  v-if="siteList[0].id != ''&&datas.product_list[0].dummy != 1 && datas.product_list[0].dummy != 2">
        </van-address-list>
        <!-- <i  style="top: 50%;font-size: 14px;margin-top: -7px"  v-if="siteList[0].id != ''&&datas.product_list[0].dummy != 1 && datas.product_list[0].dummy != 2" class="van-icon van-icon-arrow van-notice-bar__right-icon"></i> -->
      </div>
      <router-link to="user/mysite/addsite" class="van-cell-group van-hairline--top-bottom" v-if="siteList[0].id == ''&&(datas.product_list[0].dummy != 1&&datas.product_list[0].dummy != 2)">
        <div class="van-cell van-hairline add_address">
          <div class="van-cell__value van-cell__value--alone"><i class="theme-col van-icon iconfont icon-shouhuodizhi"></i>添加收货地址<i style="top: 40px;font-size: 12px;" class="van-icon van-icon-arrow van-notice-bar__right-icon"></i></div>
        </div>
      </router-link>
      <!--商品信息-->
      <van-card class="goodsonelist" v-for="items in datas.product_list" :key="items.id">
        <div slot="thumb" class="goodsimgbox">
          <img :src="items.product_img" onerror="src='/static/errorimg1.png'">
        </div>
        <div slot="title" class="ellipseal van-card-title"><van-tag plain class="theme-col theme-bd jd" v-if="items.dummy == 3">京东</van-tag>{{ items.product_name }}</div>
        <div v-if="prized==undefined"  slot="desc" class="van-card-desc">{{ items.points_price }} </div>
        <div slot="footer" style="position: absolute;bottom:10px;right: 10px;">
          x{{ items.nums }}
        </div>
      </van-card>
      <!--备注-->
      <div class="van-cell van-hairline van-field van-field--min-height">
        <div><span>备注</span>
        </div>
        <div class="van-cell__value" style="margin-left:15px">
          <textarea placeholder="请输入备注信息" v-model="content" class="van-field__control"></textarea>
        </div>
      </div>
      <!--底部按钮-->
      <div class="van-submit-bar">
        <div class="van-submit-bar__bar" style="justify-content: space-between;padding: 0 5px;">
          <div  class="van-submit-bar__price">
            <div  v-if="prized==undefined">
              <span>合计：</span><span class="van-submit-bar__price-interger">{{ datas.product_total }}</span>
            </div>
          </div>
          <van-button class="van-button van-button--normal theme-bg theme-bd " :loading="btnLoading" @click="commit()">提交订单</van-button>
        </div>
      </div>
    </div>
    <!--地址选择侧滑菜单-->
    <Choose-Site ref="ChooseSite" v-on:listenSitedata="setSite" v-if="chooseSite"></Choose-Site>
  </div>
</template>

<script>
  import ChooseSite from '@/pages/affirmorder/choosesite'
  import store from './../../vuex/store'
  export default {
    name: "index",components: {
      ChooseSite,
    },
    store,
    data () {
      return {
        btnLoading:false,//提交按钮状态
        datas:'',//商品数据
        chosenAddressId: '',//收货地址ID
        mobile:'',//手机号
        content:'',//备注
        prized:this.$route.query.prized,
        siteList: [
          {
            id: '',
            name: '',
            tel: '',
            address: ''
          }
        ],//收货地址数据
        checkNum:false,
        robid:'',
      }
    },
    methods:{
      goBack: function () {
        history.back(-1);
      },
      onClickRight: function () {
        console.log('按钮');
      },
      mysite:function () {
        this.$router.push({path:'/user/mysite'})
      },
      getDatas:function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/JifenOrder/CreatOrder/confirm', {token:isUser}, res => {
          this.datas = res.data.data
          if(res.data.data.product_list[0].is_rob==1){
            this.checkNum=true
            this.robid=res.data.data.product_list[0].id
          }
          if(res.data.data.addr_item != null){
            this.chosenAddressId = res.data.data.addr_item.id
            this.siteList[0].id = res.data.data.addr_item.id
            this.siteList[0].name = res.data.data.addr_item.name
            this.siteList[0].tel = res.data.data.addr_item.mobile
            this.siteList[0].address = res.data.data.addr_item.addressInfo + res.data.data.addr_item.address
          }
          if(res.data.errCode == '3009'){
            this.goBack()
          }
        })
      },
      chooseSite:function () {
        this.$refs.ChooseSite.chooseSiteShow()
      },
      setSite:function (data,id) {
        this.siteList[0] = data
        this.chosenAddressId = id
      },
      commit:function () {
        if(this.checkNum==true && typeof(this.prized)=='undefined'){
          this.checknum()
        }else{
          this.sendDadas()
        }
      },
      checknum:function () {
        this.$api.post('WebApi/product/Product/stock', {product_id:this.robid,num:1,is_rob:1}, res => {
          if(res.data.errCode == '2033'){
            this.$dialog.confirm({
              title:'提示',
              message: res.data.desc
            }).then(() => {
              this.sendDadas()
            }).catch(() => {
              // on cancel
              this.$router.push({path:'/user'})
            });
          }else if(res.data.errCode == '0000'){
              this.sendDadas()
          }
        })
      },
      sendDadas:function () {
        this.btnLoading = true
        var isUser = localStorage.getItem("BLHuser")
        if(typeof(this.prized)=='undefined' ){
          this.$api.post('WebApi/JifenOrder/CreatOrder/creatOrder', {token:isUser,addr_id:this.chosenAddressId,mobile:this.mobile,content:this.content}, res => {
            this.btnLoading = false
            if(res.data.errCode == '0000'){
              this.$router.push({name:'OrderSucceed',query:{orderId:res.data.data.order_sn}})
              this.$store.commit('userinfo')
            }else if(res.data.errCode == '4004'){
              window.location.href=res.data.data+"&token="+isUser+"&payurl="+window.location.host+"/ordersucceed"+"&orderlisturl="+window.location.host+'/user/myorder/allorder/'
            }else{
              this.$toast(res.data.desc);
            }
          })
        }else{
            this.$api.post('WebApi/Member/Winning/confirm', {token:isUser,addr_id:this.chosenAddressId,mobile:this.mobile,activity_winning_id:this.prized}, res => {
              this.btnLoading = false
              if(res.data.errCode == '0000'){
                this.$store.commit('userinfo')
                this.$router.push({name:'OrderSucceed',query:{orderId:res.data.data.order_sn}})
              }else if(res.data.errCode == '4004'){
                window.location.href=res.data.data+"&token="+isUser+"&payurl="+window.location.host+"/ordersucceed"+"&orderlisturl="+window.location.host+'/user/myorder/allorder/'
              }else{
                this.$toast(res.data.desc);
              }
            })
        }
      },
    },
    mounted () {
      this.getDatas()
    },
  }
</script>

<style lang="less">
  .affirmorderindex{
    .van-content{
      padding-bottom: 0;
    }
    .popupleft{
      width: 100%;
      height: 100%;
    }
    .van-cell{
      background-color: #fff;
    }
    .van-cell-group{
    	margin-top: 3px;
    	background-color: #fff;
    }
    .van-cell:not(:last-child)::after{
      border-bottom-width:0;
    }
    .van-address-list__add{
      display: none;
    }
    .address-list .van-address-list__group{
      padding-bottom: 0px;
      background: #fff;
      background: url("/static/images/addreLine.png") no-repeat center;
	    background-size:100% 100%;
    }
    .van-address-list__group{
      padding-bottom: 0px;
      background: #fff;
      /*background: url("/static/images/addreLine.png") no-repeat center;
	    background-size:100% 100%;*/
    }

	  .icon-shouhuodizhi{
	  	font-size: 22px;
	  	margin-right: 10px;
	  	line-height: 70px;
	  }
	  .add_address{
	  	height: 90px;
	  	background-color:#FFF ;
	  	background: url("/static/images/addreLine.png") no-repeat center;
	    background-size:100% 100%;
	  }

    .van-address-list__edit{
      display: none;
    }
    .van-button--large{
      width: 90%!important;
      margin-left: 5%;
      margin-top: 50px;
    }

  }

  .goodsonelist{
    position: relative;
  }

</style>



// WEBPACK FOOTER //
// src/pages/affirmorder/index.vue